type Arguments<T> = [T] extends [(...args: infer U) => any]
  ? U
  : [T] extends [void]
  ? []
  : [T];

export class EventEmitter<Events extends Record<string, Function>> {
  private listeners: {
    [E in keyof Events]: Events[E][];
  } = Object.create(null);

  addListener<E extends keyof Events>(event: E, listener: Events[E]) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
    return this;
  }

  removeListener<E extends keyof Events>(event: E, listener: Events[E]) {
    const listeners = this.listeners[event];
    if (listeners) {
      const index = listeners.findIndex((l) => l === listener);
      if (index > 0) {
        listeners.splice(index, 1);
      }
    }
    return this;
  }

  emit<E extends keyof Events>(event: E, ...args: Arguments<Events[E]>) {
    const listeners = this.listeners[event];
    if (listeners) {
      listeners.forEach((l) => l.apply(null, args));
    }
  }
}
